module.exports = __webpack_public_path__ + "static/media/coffee_video.3f29dc39.jpg";